import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import  './css/bootstrap.css';
import  './css/style.css';
import  './components/core'

ReactDOM.render(<App />, document.getElementById('root'));